import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
const header = document.querySelector('[js-header]')

const items = document.querySelectorAll('[js-nav-item-mobile]')
const submenu = document.querySelectorAll('[js-nav-submenu-mobile]')
const mobileItems = document.querySelectorAll('.nav-mobile-item')
const menuBtn = document.querySelector('.header-nav-btn')
const menuBtnReturn = document.querySelector('.header-nav-return')
const navMobile = document.querySelector('.header-nav-mobile .nav')

let timer = null 
let isOpenMobile = false

let data = {
  isActive: null
}

items.forEach((item, index) => {
  item.addEventListener('click', () => {
    for (const mobileItem of mobileItems) {
      mobileItem.style.opacity = 0;
      mobileItem.style.transform = 'translateX(-110%)';
      submenu[index].style.display = 'block'
      menuBtn.style.display = 'none'
      menuBtnReturn.style.display = 'block'
      setTimeout(() => {
        submenu[index].style.opacity = 1
        data.isActive = index
      }, 400)
    }
  })
})

if (menuBtn) {
  menuBtn.addEventListener('click', () => {
    if (!isOpenMobile) {
      navMobile.style.display = 'flex'
      menuBtn.classList.add('is-open')  
      disableBodyScroll(document.body)
    } else {
      navMobile.style.display = 'none';
      menuBtn.classList.remove('is-open')
      data.isActive = null
      enableBodyScroll(document.body)
    }
    isOpenMobile = !isOpenMobile
  })

  menuBtnReturn.addEventListener('click', () => {
    menuBtnReturn.style.display = 'none'
    menuBtn.style.display = 'flex'

    clearTimeout(timer)
    submenu[data.isActive].style.opacity = 0
    timer = setTimeout(() => {
      submenu[data.isActive].style.display = 'none'
      for (const mobileItem of mobileItems) {
        mobileItem.style.opacity = 1;
        mobileItem.style.transform = 'translateX(0%)';
      }
    }, 400)
  })
}

window.addEventListener('resize', () => {
  if (window.innerWidth >= 1024) {
    for (const mobileItem of mobileItems) {
      mobileItem.style = ''
    }
    for (const item of submenu) {
      item.style = '';
    }
    
    isOpenMobile = false
    navMobile.style = '';
    menuBtn.style = '' 
    menuBtnReturn.style = ''
    menuBtn.classList.remove('is-open')
  
    data.isActive = null
    enableBodyScroll(document.body)
  }
})
